import { useState, useEffect, useContext } from 'react'
import AuthContext from 'contexte/AuthContext'
import PageLoader from 'components/pageLoader/PageLoader'
import Tableau from 'components/DataComponents/Tableau/Tableau'
import { useTranslation } from 'react-i18next';
import Notification from 'components/notifications/Notification'
import TickerImage from 'components/DataComponents/TickerImage/TickerImage'
import { formatDate, BOT_RELEASE_DATE, } from 'utils/date'
import Badge from 'components/Badge/Badge'
import colors from 'assets/colors'
import { formatNumberWithSpaces } from 'utils/numbers'
import { fetchBotUserTransactions } from 'services/botServices'
import { useParams, useSearchParams } from 'react-router-dom'
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import DateRangeSelector from 'components/Filters/DateSelector/DateSelector'
import FilterComponent from 'components/Filters/FilterComponent/FilterComponent'
import './botUserTransactions.css'
import { bot_id_display_map } from 'utils/display';





const BotUserTransactions = () => {

  const { user } = useContext(AuthContext)
  const { t } = useTranslation()

  const { bot_id, user_uuid } = useParams()
  const [searchParams] = useSearchParams()
  const [isLoading, setIsLoading] = useState(true)
  const [transactions, setTransactions] = useState([])
  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(10)

  const [selectedDate, setSelectedDate] = useState({
    date1: { startDate: new Date(BOT_RELEASE_DATE), endDate: new Date() },
    date2: { startDate: null, endDate: null },
  });

  const tableHeaders = ['Ticker', 'Quantité', 'Ticker Value', 'Side', 'Type', 'Realized Pl', 'Date']




  const fetchData = async () => {
    try {
      const data = await fetchBotUserTransactions(user, bot_id, user_uuid, selectedDate.date1.startDate, selectedDate.date1.endDate, page, limit)
      setTransactions(data)
    } catch (error) {
      console.error('BotUserTransactions::fetchData', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [page, limit, selectedDate.date1.startDate, selectedDate.date1.endDate])


  const transformeDataToTbody = (data) => {
    return data.length && data.map((item, index) => {
      if (!item) return { data: [] }

      return {
        data: [
          <TickerImage ticker={item.ticker} />,
          formatNumberWithSpaces(item.amount),
          formatNumberWithSpaces(item.ticker_value),
          <Badge
            text={item.side}
            color={colors.badge[item.side]}
          />,
          <Badge
            text={item.side === 'LONG' ? (item.type === 'BUY' ? 'ACHAT' : 'VENTE') : item.type}
            color={colors.badge[item.type]}
          />,
          formatNumberWithSpaces(item.realized_pl),
          formatDate({ date: item.filled_at, time: true })
        ],
        utils: {
          side: item.side,
          id: item.id
        }
      }
    })
  }

  return (
    <DashboardLayout page={`${t("pages_name.bot_transactions")}`}>
      <div className='bots_title_component'>
        <h2>{t("pages.bot_transactions.title")}</h2>
      </div>
      <h3>Réalisé par {bot_id_display_map[bot_id] || bot_id} pour {searchParams.get('user_name')} <span className='bot_title_span'>({user_uuid})</span></h3>

      <div className="bots_date_contaier">
      </div>
      <div className=''>
        <Notification />
        {
          !isLoading ? (
            <div className='bots_container'>

              <div className="bots_transactions_filter_container">
                <DateRangeSelector selectedDate={selectedDate} setSelectedDate={setSelectedDate} withComparaison={false} />
                <FilterComponent
                  limit={true}
                  fetchLimit={limit}
                  setFetchLimit={setLimit}
                />
              </div>

              <Tableau
                tbody={transformeDataToTbody(transactions)}
                thead={tableHeaders}
                limit={limit}
                pagination={true}
                setPage={setPage}
                page={page}
              />



            </div>
          ) : (
            <div className='pageLoaderBox'>
              <PageLoader />
            </div>
          )
        }
      </div>
    </DashboardLayout>
  )
}

export default BotUserTransactions